
import React from "react";

export const SkillsRatingInfo = () => {
  return (
    <div className="text-sm">
      <div className="border-b border-gray-200 pb-2 mb-3">
        <h3 className="text-lg font-semibold text-red-500 flex items-center gap-2">
          <span className="inline-block">📌</span> 
          มิติที่ 2: ทักษะ (Skills)
        </h3>
        <p className="text-gray-600 mt-1">วัดจาก: การทำโจทย์ / การประยุกต์ใช้ความรู้ / การคิดวิเคราะห์</p>
      </div>

      <div className="space-y-4">
        {/* 5 คะแนน */}
        <div>
          <h4 className="font-semibold">5 คะแนน = ระดับเชี่ยวชาญ (Mastery)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ทำโจทย์ถูกทั้งหมดด้วยตัวเอง โดยไม่ต้องถามครู</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>สามารถอธิบายวิธีคิดของตัวเองได้ชัดเจน</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ทำโจทย์ประยุกต์ที่ยากขึ้นได้</span>
            </li>
          </ul>
        </div>

        {/* 4 คะแนน */}
        <div>
          <h4 className="font-semibold">4 คะแนน = ระดับเข้าใจดี (Proficient)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ทำโจทย์ได้ มากกว่า 80% ถูกต้อง</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>บางครั้งต้องให้ครูช่วยชี้แนะแนวทางเล็กน้อย</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>เริ่มสามารถใช้แนวคิดเดิมประยุกต์กับโจทย์ใหม่ๆ ได้</span>
            </li>
          </ul>
        </div>

        {/* 3 คะแนน */}
        <div>
          <h4 className="font-semibold">3 คะแนน = ระดับปานกลาง (Developing)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ทำโจทย์ได้ 50-79% ถูกต้อง</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ยังมีข้อผิดพลาดในวิธีทำหรือความเข้าใจหลักการ</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ต้องให้ครูอธิบายเพิ่มเติมในบางจุดก่อนทำได้ถูกต้อง</span>
            </li>
          </ul>
        </div>

        {/* 2 คะแนน */}
        <div>
          <h4 className="font-semibold">2 คะแนน = ระดับต้องปรับปรุง (Emerging)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ทำโจทย์ได้ 30-49% ถูกต้อง</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ติดขัดในการคิดวิเคราะห์ ต้องให้ครูช่วยทีละขั้นตอน</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>แก้ปัญหาที่ซับซ้อนได้ยาก</span>
            </li>
          </ul>
        </div>

        {/* 1 คะแนน */}
        <div>
          <h4 className="font-semibold">1 คะแนน = ระดับยังไม่เข้าใจ (Beginning)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ทำโจทย์ผิดเกือบทั้งหมด (ต่ำกว่า 30%)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ไม่สามารถเริ่มแก้โจทย์เองได้ ต้องให้ครูช่วยทั้งหมด</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ไม่เข้าใจหลักการของโจทย์</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SkillsRatingInfo;
